// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","261":"1c76626d","513":"cf39e27b","706":"711ede07","726":"759a3e6d","881":"e66cd213"}[chunkId] + ".chunk.js";
};